<template>
    <div class="main" >
        <div v-if="loading" class="loading-form" style="min-height: 130px;">
            <img src="/public/img/loading-bar.gif" />
        </div>
        <div v-else>
            <div class="card-registro-frequencia" v-if="showCardAcao">
                <div class="level" style="margin-bottom: 40px;" @click="realizaFrequenciaHoje">
                    <div class="icone">
                        <img src="/public/img/alunos.png" />
                    </div>
                    <div class="info">
                        <div class="titulo-card">De hoje</div>
                    </div>
                </div>
                <div class="level" @click="realizaFrequenciaOutraData">
                    <div class="icone">
                        <img src="/public/img/alunos.png" />
                    </div>
                    <div class="info">
                        <div class="titulo-card">De outra data</div>
                    </div>
                </div>
            </div>
            <template v-else>
                <c-panel >
                    <datas 
                        v-if="step == 1" 
                        :param="dados"
                    />
                    <turmas 
                        v-if="step == 2" 
                        :param="dados"
                    />
                    <disciplinas 
                        v-if="step == 3" 
                        :param="dados"
                        :turmaSelected="turmaSelected"
                    />
                    <horarios 
                        v-if="step == 4" 
                        :turmaSelected="turmaSelected"
                    />
                    <alunos 
                        v-if="step == 5" 
                        :turmaSelected="turmaSelected"
                        :dataSelected="form.data"
                        :horariosSelected="form.horarios"
                        @frequenciaCadastrada="frequenciaCadastrada"
                    />
                </c-panel>
            </template>
        </div>
    </div>
</template>
<script>

import datas from "./datas"
import turmas from "./turmas"
import disciplinas from "./disciplinas"
import horarios from "./horarios"
import alunos from "./alunos"

export default {
    components:{ 
        datas,
        turmas,
        disciplinas,
        horarios,
        alunos
    },
    data () {
        return {
            loading: true,
            showCardAcao: false,
            dados: {},
            step: 1,
            form: {
                data: '',
                turma: '',
                disciplina: '',
                horarios: [],
                alunos: []
            },
            turmaSelected: {}

        }
    },
    mounted () {

        this.initFormFrequencia();
    },
    methods:{
        realizaFrequenciaOutraData(){
            this.step = 1;
            this.showCardAcao = false;
        },
        realizaFrequenciaHoje(){

            let data = this.$moment().format('YYYY-MM-DD');
            this.$router.push(`/admin/diario/frequencia?data=${data}`);  
            this.showCardAcao = false;

        },
        frequenciaCadastrada(alunos){

            this.form.alunos = alunos;
            this.onSubmitFrequencia();
        },
        async onSubmitFrequencia(){

            let response = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/frequencia/storeFrequencia`, this.form, this.$store.getters.getHeaderAuth);

            if(typeof response.data.erro !== 'undefined'){

                window.eventBus.$emit('loading', false);
                window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});

            }else{

                window.eventBus.$emit('loading', false);
                window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                this.form =  {
                    data: '',
                    turma: '',
                    disciplina: '',
                    horarios: [],
                    alunos: []
                };

                this.$router.push(`/admin`);  
            }

        },
        async initFormFrequencia(){

            this.loading = true;

            let i = this.$store.state.config.instituicao.id;
            let p = this.$store.state.config.periodo.id;

            let response = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/frequencia/initFormFrequencia/${i}/${p}`, this.$store.getters.getHeaderAuth);
            this.dados = JSON.parse(JSON.stringify(response.data));

            let dataAtual = this.$moment().format('YYYY-MM-DD')

            for(let i in response.data.datas){              
                if(response.data.datas[i] == dataAtual){
                    this.showCardAcao = true;
                }
            }

            this.changeRota();

            this.loading = false;
        },
        changeRota(){

            this.form =  {
                data: '',
                turma: '',
                disciplina: '',
                horarios: [],
                alunos: []
            };

            if(!this.$route.query['data'] && !this.$route.query['turma'] && !this.$route.query['disciplina'] && !this.$route.query['horarios']){
                for(let i in this.dados.datas){
                    if(this.dados.datas[i] == this.$moment().format('YYYY-MM-DD')){
                        this.showCardAcao = true;
                    }
                }
                this.step = 1;
            }

            if(this.$route.query['data']){
                this.step = 2;
                this.showCardAcao = false;
                this.form.data = this.$route.query['data'];
            }

            if(this.$route.query['turma']){                  

                for(let i in this.dados.turmas){
                    if(this.dados.turmas[i].id == this.$route.query['turma']){
                        this.turmaSelected = this.dados.turmas[i];
                    }
                }

                this.form.turma = this.$route.query['turma'];

                if(this.turmaSelected.qtd_horarios == 1){

                    this.form.disciplina = 'f1';
                    this.form.horarios = [];

                    this.showCardAcao = false;
                    this.step = 5;

                }else{

                    this.showCardAcao = false;
                    this.step = 3;
                }
            }

            if(this.$route.query['disciplina']){
                this.showCardAcao = false;
                this.step = 4;
                this.form.disciplina = this.$route.query['disciplina'];
            }
            
            if(this.$route.query['horarios']){
                this.showCardAcao = false;
                this.step = 5;
                this.form.horarios = this.$route.query['horarios'].split(",");
            }

            
        }
    },
    watch: {
        '$route.query': {
            handler (value) {
                this.changeRota();
            }
        },
    }
    
}
</script>
<style>
    .card-registro-frequencia {
        height: 85vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .card-registro-frequencia .level {
        width: 500px;
    }
</style>
